import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { DefaultLandingPageApi, landingPageApiRef } from './api';
import { rootRouteRef } from './routes';

export const landingPagePlugin = createPlugin({
  id: 'landing-page',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: landingPageApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new DefaultLandingPageApi({ discoveryApi, identityApi }),
    }),
  ],
});

export const LandingPageContent = landingPagePlugin.provide(
  createRoutableExtension({
    name: 'LandingPageContent',
    component: () =>
      import('./components/LandingPageContent').then(m => m.LandingPageContent),
    mountPoint: rootRouteRef,
  }),
);
